import React from 'react';
import styles from './RadioButton.module.scss';

type Props = {
  label?: string;
  value: string;
  group: string;
  id: number;
  checked?: boolean;
  onChange: (value: string) => void;
};

export const RadioButton: React.FC<Props> = ({
  group,
  value,
  label,
  id,
  checked,
  onChange,
}) => {

  const onChangeHandler = (e:React.ChangeEvent<HTMLInputElement>): void => {
    onChange(e.currentTarget.value);
  };

  return (
    <label className={styles.radioButton__wrapper}>
      <input
        onChange={onChangeHandler}
        type="radio"
        name={group}
        id={Number(id).toString()}
        value={value}
        className={styles.radioButton}
        checked={checked}
      />
      {label && (<span className={styles.radioButton__label}>{label}</span>)}
    </label>
  );
};
